import {useAuthContext} from 'geestack-toolbox';
import {IUser} from '../hooks/User';
import {UserDto} from '../scaffold';

export default function useAuth() {
  return useAuthContext<UserDto>();
}
